import { Link } from "@shopify/hydrogen";
import ImageGrid from "../home/components/home-components/image-grid";
import ErrorBanner from "./components/ErrorBanner";
import Carousel from "../elements/Carousel";
import { gridImages } from "../home/imagesAndText";

export const NotFoundDetail = ({ data }) => {
  const carouselClass =
    "flex w-full px-4 items-center gap-10 snap-x overflow-x-scroll snap-mandatory scrollbar-hide";
  const products = data?.collection?.products?.nodes || [];

  return (
    <div className="w-full flex flex-col justify-start items-center md:gap-0 gap-10 mb-10">
      <ErrorBanner />
      <div className="w-full flex justify-center items-center md:gap-10 gap-6 px-[10px] md:mt-10 mt-0 font-gotham-bold">
        <Link
          to="/"
          className="uppercase md:w-[200px] w-[160px] box-border px-4 h-[37px] grid place-content-center text-white bg-gradient-to-r from-[#570054] to-[#AF00A9] md:text-sm md:leading-[17.72px] text-xs leading-[15.19px]"
        >
          all new arrivals
        </Link>
        <Link
          to="/store-locator"
          className="uppercase md:w-[200px] w-[160px] box-border px-4 h-[37px] grid place-content-center bg-white text-[#0C2340] border border-[#0C2340] md:text-sm md:leading-[17.72px] text-xs leading-[15.19px]"
        >
          find dealer
        </Link>
      </div>
      <ImageGrid data={gridImages} />
      <h1 className=" text-[30px] leading-[34px] text-center text-[#2A3238] md:mb-10 mb-0">
        OUR BEST SELLERS
      </h1>
      <Carousel
        products={products}
        align={"items-start"}
        width={"w-full"}
        carouselClass={carouselClass}
        productWidth={"w-full"}
        productMinWidth={"min-w-[300px]"}
      />
    </div>
  );
};
